import { render, staticRenderFns } from "./UnreadCountBadge.vue?vue&type=template&id=13313f10&scoped=true&"
import script from "./UnreadCountBadge.vue?vue&type=script&lang=ts&"
export * from "./UnreadCountBadge.vue?vue&type=script&lang=ts&"
import style0 from "./UnreadCountBadge.vue?vue&type=style&index=0&id=13313f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13313f10",
  null
  
)

export default component.exports